import { render, staticRenderFns } from "./FileUuidDownloadLink.vue?vue&type=template&id=14d0957e"
import script from "./FileUuidDownloadLink.vue?vue&type=script&lang=js"
export * from "./FileUuidDownloadLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports